import { styled, Typography } from '@mui/material'

type StateVisualizerProps = {
  state: 'live' | 'ended'
}

export const StateVisualizer = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'state',
})<StateVisualizerProps>(({ theme }) => ({
  width: 80,
  textAlign: 'center',
  display: 'inline-block',
  padding: theme.spacing(0.3),
  margin: theme.spacing(0),
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.getContrastText(theme.palette.grey[100]),
  borderRadius: theme.shape.borderRadius,
}))
